import { Divider, Tabs, Theme, useMediaQuery } from "@material-ui/core";
import * as React from "react";
import { FC, Fragment } from "react";
import {
  BooleanField,
  Datagrid,
  Filter,
  FilterProps,
  List,
  ListContextProvider,
  ListProps,
  SelectInput,
  TextField,
  TextInput,
  useListContext,
} from "react-admin";
import { DetailButton } from "../../../src/Components/DetailButton";
import CreatedByField from "../../../src/Components/ReferenceFields/CreatedBy/CreatedByField";
import { ExcelExport } from "../../../src/Helper/ExportExcel";
import { CustomDateField } from "../../Components/CustomDateField";
import { CustomDatetime } from "../../Components/CustomDatetime";
import {
  DefaultCreatedDateSort,
  DefaultIsActiveFilter,
  DefaultPerPageSize,
  QuarantineLocations,
} from "../../Constants/Constant";
import { TabbedDatagridProps } from "../../Models/TabbedDataGridProps";
import { QuarantineExcelHeader, QuarantineExcelName } from "./Constant/Excel";
import { SourceQuarantine, TitleQuarantine } from "./Constant/Source";
import QuarantineListDetail from "./QuarantineListDetail";

const QuarantineFilter: FC<Omit<FilterProps, "children">> = props => (
  <Filter {...props}>
    <TextInput label="Ref No" source="refNo__contains" alwaysOn />
    <TextInput label="Customer Name" source="customerName__contains" alwaysOn />
    <TextInput label="Customer Code" source="customerPo__contains" alwaysOn />
    <TextInput label="Pn" source="pn__contains" alwaysOn />
    <TextInput label="Sn" source="sn__contains" alwaysOn />
    <TextInput label="Awb No" source="awbNo__contains" />
    <SelectInput
      source="location__contains"
      label="LOCATION"
      optionText="locations"
      optionValue="value"
      fullWidth
      choices={QuarantineLocations}
      alwaysOn
    />
    <CustomDatetime source="createdDate__gte" label="Tarih(>=)" />
    <CustomDatetime source="createdDate__lte" label="Tarih (<=)" />
  </Filter>
);

const ExportToExcel = data => {
  ExcelExport(
    QuarantineExcelHeader,
    data.map(v => [
      v.refNo,
      v.customerName,
      v.customerPo,
      v.pn,
      v.sn,
      v.awbNo,
      v.location,
      v.unproperPacking,
      v.createdBy,
      v.createdDate,
      v.accomplishDate,
      v.quarantineRemark,
    ]),
    QuarantineExcelName
  );
};

const TabbedDatagrid: FC<TabbedDatagridProps> = props => {
  const listContext = useListContext();
  const isXSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down("xs"));

  return (
    <Fragment>
      <Tabs variant="fullWidth" centered indicatorColor="primary"></Tabs>
      <Divider />
      {isXSmall ? (
        <ListContextProvider value={{ ...listContext }}>
          <></>
        </ListContextProvider>
      ) : (
        <ListContextProvider
          value={{
            ...listContext,
          }}
        >
          <Datagrid {...props} optimized hasBulkActions={false} expand={<QuarantineListDetail />}>
            <DetailButton label="Actions" resource={SourceQuarantine} />
            <TextField source="refNo" label="REF NO" />
            <TextField source="customerName" label="CUSTOMER NAME" />
            <TextField source="customerPo" label="CUSTOMER CODE" />
            <TextField source="pn" label="PN" />
            <TextField source="sn" label="SN" />
            <TextField source="awbNo" label="AWB NO" />
            <TextField source="location" label="LOCATION" />
            <BooleanField source="unproperPacking" label="UNPROPER PACKING" />
            <CreatedByField label="CREATED BY" link={false} />
            <CustomDateField source="createdDate" label="CREATED DATE" showTime />
            <CustomDateField source="accomplishDate" label="ACCOMPLISH DATE" showTime />
            <TextField source="quarantineRemark" label="QUARANTINE REMARK" />
          </Datagrid>
        </ListContextProvider>
      )}
    </Fragment>
  );
};

const QuarantineList: FC<ListProps> = props => (
  <List
    {...props}
    title={TitleQuarantine.list}
    filterDefaultValues={DefaultIsActiveFilter}
    sort={DefaultCreatedDateSort}
    perPage={DefaultPerPageSize}
    exporter={ExportToExcel}
    filters={<QuarantineFilter />}
  >
    <TabbedDatagrid />
  </List>
);

export default QuarantineList;
